






































































































import Vue from 'vue'
import debounce from 'lodash.debounce'
import { mapState, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { atcb_action } from 'add-to-calendar-button'
import ExplorerSearch from '~/pages/reg/-/ExplorerSearch.vue'
import { ACCOUNT_STATUS, ACCOUNT_SUFFIX, CHAR_TYPE, DEBOUNCE_WAIT_TIME } from '~/constant'
import { ISearchAccount } from '~/services/Explorer'
import AccountStatus from '~/pages/reg/-/AccountStatus.vue'
import { IConnectedAccount, ME_KEYS } from '~/store/me'
import { accountChars, digitalEmojiHandle, isMobile, splitAccount, toDottedStyle, appendBaseUrl } from '~/modules/tools'
import { COMMON_KEYS } from '~/store/common'
import { IConfig } from '~/services/Common'
import config from '~~/config'
import errno from '~/constant/errno'
import { LANGUAGE } from '~/constant/language'
import Iconfont from '~/components/icon/Iconfont.vue'
import CouponCodeTips from '~/pages/reg/-/CouponCodeTips.vue'

dayjs.extend(utc)

export default Vue.extend({
  name: 'Explorer',
  components: {
    ExplorerSearch,
    AccountStatus,
    Iconfont,
    CouponCodeTips
  },
  layout: 'explorer',
  data () {
    return {
      LANGUAGE,
      config,
      searchWord: '',
      searchResult: {} as ISearchAccount,
      loading: false,
      showIncorrectAccountFormat: false,
      showIllegalStringLength: false,
      notOpenForRegistrationShowing: false,
      registrableDate: '',
      fetchConfigTimer: 0,
      incorrectAccountFormatText: '',
      couponCode: this.$route.query['gift-card'] as string
    }
  },
  computed: {
    isMobile,
    ...mapState({
      me: ME_KEYS.namespace,
      common: COMMON_KEYS.namespace
    }),
    ...mapGetters({
      computedChainType: ME_KEYS.computedChainType
    }),
    dateOnChain (): string {
      const timestamp = this.common.config.timestamp_on_chain
      if (timestamp) {
        return dayjs(timestamp * 1000).utc().format('YYYY-MM-DD hh:mm:ssA')
      }
      else {
        return dayjs().utc().format('YYYY-MM-DD hh:mm:ssA')
      }
    },
    connectedAccount (): IConnectedAccount {
      return this.me.connectedAccount
    },
    commonConfig (): IConfig {
      return this.common.config
    },
    accountStatusShown (): boolean {
      return Boolean(this.searchResult.account) && !this.loading
    }
  },
  async mounted () {
    await this.$store.dispatch(COMMON_KEYS.fetchConfig)
    // this.fetchConfigTimer = window.setInterval(() => {
    //   this.$store.dispatch(COMMON_KEYS.fetchConfig)
    // }, 5000)
    const _searchWord = this.$route.query.searchWord
    if (_searchWord) {
      this.searchWord = digitalEmojiHandle(_searchWord as string)
      this.onInput()
      this.onSearch(this.searchWord)
    }

    const { utmSource, utmMedium, utmCampaign } = this.me.gaUtm
    if (utmSource && utmMedium && utmCampaign) {
      this.$gtag('event', 'click', {
        event_category: 'explorer page',
        event_label: `${utmSource} ${utmMedium} ${utmCampaign}`,
        value: 1,
        utm_medium: utmMedium,
        utm_source: utmSource,
        utm_campaign: utmCampaign
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.fetchConfigTimer)
  },
  methods: {
    appendBaseUrl,
    incorrectAccountFormat (account: string) {
      const linker = this.$i18n.locale === LANGUAGE.zhCN ? '、' : ', '
      this.incorrectAccountFormatText = ''
      const list = accountChars(account)
      // Characters x, y, z are not included
      let notIncluded: string[] = []
      list.forEach((item) => {
        if (item.char_set_name === CHAR_TYPE.unknown) {
          notIncluded.push(item.char)
        }
      })
      if (notIncluded.length > 0) {
        notIncluded = [...new Set(notIncluded)]
        this.incorrectAccountFormatText = this.$tt('Characters {list} are not included.', { list: notIncluded.join(linker) })
      }
      else {
        // For safety, character x and y cannot be used in combination
        let charTypes: CHAR_TYPE[] = []
        list.forEach((item) => {
          charTypes.push(item.char_set_name)
        })
        const charTypesSet = new Set(charTypes)
        charTypesSet.delete(CHAR_TYPE.emoji)
        charTypesSet.delete(CHAR_TYPE.number)
        charTypesSet.delete(CHAR_TYPE.unknown)
        const language: { [key: string]: string } = {
          [CHAR_TYPE.english]: this.$tt('English'),
          [CHAR_TYPE.simplifiedChinese]: this.$tt('Simplified chinese'),
          [CHAR_TYPE.traditionalChinese]: this.$tt('Traditional chinese'),
          [CHAR_TYPE.japanese]: this.$tt('Japanese'),
          [CHAR_TYPE.korean]: this.$tt('Korean'),
          [CHAR_TYPE.russian]: this.$tt('Russian'),
          [CHAR_TYPE.turkish]: this.$tt('Turkish'),
          [CHAR_TYPE.thai]: this.$tt('Thai'),
          [CHAR_TYPE.vietnamese]: this.$tt('Vietnamese')
        }
        charTypes = [...charTypesSet]
        const languageList = charTypes.map((item) => {
          return language[item]
        })
        if (languageList.length > 1) {
          this.incorrectAccountFormatText = this.$tt('For safety, {list} cannot be used in combination.', { list: languageList.join(linker) })
        }
      }
    },
    checkSearchWord (value: string, isSubAccount?: boolean) {
      const splitArr = splitAccount(value)
      const nonComplianceChar = splitArr.find((item: { char_set_name: number, char: string }) => {
        return item.char_set_name === CHAR_TYPE.unknown
      })
      const accountLength = splitArr.length

      if (!isSubAccount && (accountLength < this.commonConfig.min_account_len || accountLength > this.commonConfig.max_account_len)) {
        this.showIllegalStringLength = true
      }
      this.showIncorrectAccountFormat = !!nonComplianceChar
    },
    onInput () {
      this.searchResult = {} as ISearchAccount
      this.showIncorrectAccountFormat = false
      this.showIllegalStringLength = false
      this.notOpenForRegistrationShowing = false
      this.registrableDate = ''
      this.searchWord = this.searchWord.toLowerCase()
    },
    onSearch: debounce(async function (this: any, value: string) {
      this.loading = true
      value = digitalEmojiHandle(value)
      value = value.replace(/\s+/g, '')
      value = value.toLowerCase()
      this.searchWord = value
      value = value.replace(/\.bit$/, '')
      value = value + ACCOUNT_SUFFIX
      value = toDottedStyle(value)

      this.searchResult = {
        account: value
      }
      try {
        const res = await this.$services.account.accountInfo(value)
        if (res) {
          this.searchResult = {
            account: value,
            ...res
          }
        }
        this.loading = false
        return
      }
      catch (err: any) {
        console.error(err)
      }

      value = value.replace(/\.bit$/, '')

      this.searchResult = {}
      this.showIllegalStringLength = false
      this.showIncorrectAccountFormat = false
      this.notOpenForRegistrationShowing = false
      this.registrableDate = ''

      if (!value) {
        this.loading = false
        return
      }

      this.$gtag('event', 'click', {
        event_category: 'explorer',
        event_label: 'search account',
        value: 1
      })

      const accountList = value.split('.')
      if (accountList[0]) {
        this.incorrectAccountFormat(accountList[0])
        this.checkSearchWord(accountList[0], accountList.length === 2)
      }
      if (accountList[1]) {
        this.incorrectAccountFormat(accountList[1])
        this.checkSearchWord(accountList[1])
      }

      if (this.showIncorrectAccountFormat || this.showIllegalStringLength) {
        this.loading = false
        return
      }

      this.searchResult = {
        account: value + ACCOUNT_SUFFIX
      }

      try {
        const res = await this.$services.explorer.searchAccount({
          account: value,
          chain_type: this.computedChainType,
          address: this.connectedAccount.address
        })

        if (!res.is_self && [ACCOUNT_STATUS.registeringPaymentConfirm].includes(res.status)) {
          this.searchResult = {
            account: value + ACCOUNT_SUFFIX,
            ...res,
            status: ACCOUNT_STATUS.registerable
          }
        }
        else if (!res.is_self && [ACCOUNT_STATUS.registeringLockedAccount, ACCOUNT_STATUS.registering, ACCOUNT_STATUS.registeringIncludeProposal, ACCOUNT_STATUS.registeringConfirmProposal].includes(res.status)) {
          this.searchResult = {
            account: value + ACCOUNT_SUFFIX,
            ...res,
            status: ACCOUNT_STATUS.othersRegistering
          }
        }
        else if (res) {
          if (res.status === ACCOUNT_STATUS.notOpenRegister) {
            this.searchResult = {}
            this.notOpenForRegistrationShowing = true
            this.registrableDate = res.open_timestamp ? '2022–10–18 12:00PM (UTC+0)' : ''
          }
          else {
            this.searchResult = {
              account: value + ACCOUNT_SUFFIX,
              ...res
            }
          }
        }
      }
      catch (err: any) {
        console.error(err)
        this.searchResult = {}
        if (err.code === errno.rpcApiErrAccountCharsErr) {
          this.showIncorrectAccountFormat = true
        }
        else {
          this.$alert({
            title: this.$tt('Error'),
            message: `${err.code}: ${err.message}`
          })
        }
      }
      finally {
        this.loading = false
      }
    }, DEBOUNCE_WAIT_TIME),
    addToCalendar () {
      const account = /\.bit$/.test(this.searchWord) ? this.searchWord : this.searchWord + ACCOUNT_SUFFIX
      const config = {
        name: 'All 4~9 characters .bit accounts will release to 100% at 12:00 PM(UTC+0), October 18th.',
        description: `${account} registration link: [url]https://d.id/bit/reg?searchWord=${account}[/url]`,
        startDate: '2022-10-18',
        options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'MicrosoftTeams', 'Yahoo'],
        trigger: 'click',
        iCalFileName: 'dotbit-reminder-event'
      }
      // @ts-ignore
      atcb_action(config)
      const list = document.getElementsByClassName('atcb-list-item')
      for (let i = 0; i < list.length; i++) {
        let eventLabel: any = list[i]?.childNodes[1]
        eventLabel = (eventLabel as HTMLElement).innerText
        list[i].addEventListener('click', () => {
          this.$gtag('event', 'click', {
            event_category: 'add to calendar',
            event_label: eventLabel,
            value: 1
          })
        })
      }
    }
  }
})
